import { Separator } from './ui/separator';
import { Badge } from './ui/badge';
import { Link } from 'react-router-dom';

export function Footer() {
  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'AI Consultation', href: '/ai-consultation' },
    { name: 'Partners', href: '/partners' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Terms of Service', href: '/terms-of-service' },
  ];

  const zohoServices = [
    'Zoho CRM Implementation',
    'Zoho One Consulting',
    'Zoho Analytics Setup',
    'Zoho Books Integration',
    'Zoho Desk Configuration',
    'Zoho Creator Development'
  ];

  const partners = [
    {
      name: 'Zoho',
      logo: '/assets/logos/zoho-logo.png'
    },
    {
      name: 'Razorpay',
      logo: '/assets/logos/razorpay-logo.png'
    },
    {
      name: 'Shiprocket',
      logo: '/assets/logos/shiprocket-logo.webp'
    },
    {
      name: 'MyOperator',
      logo: '/assets/logos/myoperator-logo.png'
    }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <Link to="/">
              <img
                src="/assets/logos/optiwizer-logo.png"
                alt="Optiwizer Logo"
                style={{ height: 48, background: '#fff', borderRadius: '8px', padding: '8px', marginBottom: '16px' }}
              />
            </Link>
            <p className="text-gray-300 mb-4 max-w-md">
              Transform your business with expert Zoho consulting and implementation services. 
              As an authorized Zoho partner, we help businesses optimize operations and drive growth.
            </p>
            <div className="space-y-2 mb-6">
              <Badge className="bg-blue-600 text-white">
                Zoho Authorized Partner
              </Badge>
              <div className="text-sm text-gray-400">
                <p>Expert Implementation &amp; Support</p>
                <p>45+ Zoho Applications Expertise</p>
              </div>
            </div>

            {/* Partner Logos */}
            <div>
              <h3 className="text-sm font-semibold mb-3 text-gray-300">Our Technology Partners</h3>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {partners.map((partner, index) => (
                  <div key={index} style={{ background: '#f5f7fa', borderRadius: '12px', padding: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 50 }}>
                    <img
                      src={partner.logo}
                      alt={`${partner.name} logo`}
                      style={{ maxHeight: 32, width: 'auto', maxWidth: '100%', objectFit: 'contain' }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href} 
                    className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Zoho Services */}
          <div>
            <h3 className="font-semibold mb-4">Zoho Services</h3>
            <ul className="space-y-2">
              {zohoServices.map((service) => (
                <li key={service}>
                  <span className="text-gray-300 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-gray-700" />
        
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            <p>© 2025 Optiwizer Technologies Pvt Ltd. All rights reserved.</p>
            <p className="text-xs mt-1">
              Zoho and the Zoho logo are trademarks of Zoho Corporation Pvt. Ltd.
            </p>
          </div>
          <div className="flex space-x-6 text-sm text-gray-400">
            <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
            <a href="#" className="hover:text-white transition-colors">Support</a>
          </div>
        </div>
      </div>
    </footer>
  );
}